module.exports = __webpack_public_path__ + "static/media/tutorial-dr-licita-customized-keyword-search.bfd7fc72.png";